import { render, staticRenderFns } from "./SuccessCaseDetail.vue?vue&type=template&id=7b054052&scoped=true&"
import script from "./SuccessCaseDetail.vue?vue&type=script&lang=js&"
export * from "./SuccessCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./SuccessCaseDetail.vue?vue&type=style&index=0&id=7b054052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b054052",
  null
  
)

export default component.exports